<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">탕전주문관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>주문코드</p>
                <input type="text" placeholder="입력하세요" class="form_control" v-model="searchInfo.orderCode">
              </li>
              <li>
                <p>처방의명</p>
                <input type="text" placeholder="입력하세요" class="form_control" v-model="searchInfo.doctorNm">
              </li>
              <li>
                <p>처방명</p>
                <input type="text" placeholder="입력하세요" class="form_control" v-model="searchInfo.prescribeNm">
              </li>
              <!-- <li></li> -->
              <li>
                <p>주문접수기간</p>
                <Datepicker v-model="searchInfo.startDate" :defaultDate="searchInfo.startDate" :format="'YYYY-MM-DD'" />
                <span>~</span>
                <Datepicker v-model="searchInfo.endDate" :defaultDate="searchInfo.endDate" :format="'YYYY-MM-DD'" />
              </li>
              <li>
                <p>환자명</p>
                <input type="text" placeholder="입력하세요" class="form_control" v-model="searchInfo.patientNm">
              </li>
              <li>
                <p>결제상태</p>
                  <div class="form_radio">
                  <input type="radio" id="radio1" name="radio" value="" checked v-model="searchInfo.paymentStatus">
                  <label for="radio1">전체</label>
                </div>
				        <div  class="form_radio" v-for="(item, index) in paymentStatusList" :key="index">
                  <input type="radio" :id="index" name="radio" :value="item.dtl_code" v-model="searchInfo.paymentStatus">
                  <label :for="index">{{item.dtl_code_nm}}</label>
                </div>                            
              </li>
              <li>
              <p>탕전분류</p>
                <div class="form_radio">
                  <input type="radio" id="radio_type1" name="radio_type" value="" checked v-model="searchInfo.prescribeType">
                  <label for="radio_type1">전체</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio_type2" name="radio_type" value="T" checked v-model="searchInfo.prescribeType">
                  <label for="radio_type2">탕전</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio_type3" name="radio_type" value="I" checked v-model="searchInfo.prescribeType">
                  <label for="radio_type3">첩약</label>
                </div>                          
              </li>                
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="list">
              <thead>
                <tr>
                  <th>접수일자</th>
                  <th>분류</th>
                  <th>처방명</th>
                  <th>처방의</th>
                  <th>차트번호</th>
                  <th>환자명</th>
                  <th>성별/나이</th>
                  <th>첩수</th>
                  <th>팩수</th>
                  <th>조제비용</th>
                  <th>조제상태</th>
                  <th>결제상태</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in orderList" :key="index" @click="fn_move_dtl_page(item.prescribe_seq)">
                  <td><span>{{ item.reg_dt }}</span></td>
                  <td>
                      <span v-if="item.prescribe_type == 'T'" class="font_orange">탕전</span>
                      <span v-if="item.prescribe_type == 'I'" class="font_green">첩약</span>
                      <span v-if="item.prescribe_type == 'P'" class="font_blue">약속</span>
                    </td>
                  <td class="al"><span>{{ item.prescribe_nm }}</span></td>
                  <td><span>{{ item.doctor_nm }}</span></td>
                  <td><span>{{ item.patient_chart_no }}</span></td>
                  <td><span>{{ item.patient_nm }}</span></td>
                  <td><span>{{ item.patient_gender_nm }} / {{item.patient_age}}</span></td>
                  <td><span>{{ item.prescribe_pack_cnt }}</span></td>
                  <td><span>{{ item.packs_cnt }}</span></td>
                  <td><span>{{ fn_comma_won(item.total_payment) }}</span></td>
                  <td><span>{{ item.work_status_nm }}</span></td>
                  <td><span>{{ item.payment_status_nm }}</span></td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo"  @clickPage="fn_movePage" v-show="pagingShow"/>
          </div>
        </section>
      </div>

    </div>
</template>

<script>
  import axios from 'axios'
  import commonUtil from "@/mixin/commonUtil";
  import Pagination from "@/components/AdminPagination.vue"
  import Datepicker from '@/components/Datepicker.vue'

  export default {
    name: 'OrderMngt',
    components: {
      Pagination,
      Datepicker
    },
    mixins: [commonUtil],
    data() {
      return {
        searchInfo : {
            orderCode : '',
            doctorNm : '',
            prescribeNm : '',
            patientNm : '',
            startDate : '',
            endDate : '',
            paymentStatus : '',
            prescribeType : '',            
            pageInfo : {
                page : 1,
                pageSize : 10,
                totPage : 0
            }              
        },
        pagingShow : false,
        orderList: [],
        selected: null,
        paymentStatusList : []
      }
    },
    async created(){

      //공통코드 - payment 상태
      this.paymentStatusList = await this.getCode('GC00000013');         

      let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
      if(searchInfoStore != null && searchInfoStore != {}){
          this.searchInfo = searchInfoStore;
      }
    },
    mounted(){ 
      
        //오늘 날짜구하기
        this.searchInfo.startDate =  this.getAddMonthDate(-3);
        this.searchInfo.endDate = this.getCurrentDate();

        this.fn_search();
    },
    methods : {
      fn_search(){
          console.log("@@@ search : ",this.searchInfo);

          this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo); 

          axios
              .post("/api/admin/orderPayment/getOderList", this.searchInfo)
              .then((res) => {
                  console.log("@@@@ res : %o",res);
                  this.orderList = res.data.orderList;

                  console.log("@@@@ orderList : %o",this.orderList);

                  this.searchInfo.pageInfo.totPage = res.data.totCnt;
                  
                  if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;                          
                  }                        

              })
              .catch((err) => console.log(err));
      },
      fn_movePage(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
      },
      fn_move_dtl_page(code){
          this.$store.dispatch('orderPaymentMngt/setPrescribeSeq', code); 
          this.$router.push({ name : 'OrderTangjunDetail'});
      },
    }
  }
</script>